exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._18WYDAKKXRihibwovsl1BF{min-height:0;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;height:100%}.tYfIGJ33bwgdHlX33siw3,._18WYDAKKXRihibwovsl1BF{display:-webkit-box;display:-ms-flexbox;display:flex}.tYfIGJ33bwgdHlX33siw3{height:63px;width:100%}html[dir=ltr] .tYfIGJ33bwgdHlX33siw3{margin:1px 0 0 1px}html[dir=rtl] .tYfIGJ33bwgdHlX33siw3{margin:1px 1px 0 0}", ""]);
// Exports
exports.locals = {
	"wrapper": "_18WYDAKKXRihibwovsl1BF",
	"shimmerItemWrapper": "tYfIGJ33bwgdHlX33siw3"
};